<template>
    <form novalidate @submit.prevent="handleSubmit">
        <div>
            <DsInputField
                ref="nameInput"
                v-model="name"
                name="name"
                label="Name"
                required
                :submitted="isSubmitted"
            >
                <template #error>
                    This field is required to save your template
                </template>
            </DsInputField>
        </div>

        <div>
            <DsFilledButton type="submit" :loading="isSaving">
                Save
            </DsFilledButton>
        </div>

        <div v-if="isError" class="alert-container">
            <DsInlineAlert type="critical" leading-icon="alert-circle">
                For some reason your template name didn't save. Try refreshing the page then try again.
            </DsInlineAlert>
        </div>
    </form>
</template>

<script>
import { renameSavedEmailFunnelTemplate } from '@/api/campaigns/campaignUnlayerEmail';

const STATUS_UNSUBMITTED = 'UNSUBMITTED';
const STATUS_SUBMITTED = 'SUBMITTED';
const STATUS_SAVED = 'SAVED';
const STATUS_SAVING = 'SAVING';
const STATUS_ERROR = 'ERROR';

export default {
    props: {
        template: Object,
    },

    data() {
        return {
            name: this.template.name,
            status: STATUS_UNSUBMITTED,
        };
    },

    mounted() {
        this.focusNameInput();
    },

    computed: {
        isSaving() {
            return this.status === STATUS_SAVING;
        },

        isSubmitted() {
            return this.status !== STATUS_UNSUBMITTED;
        },

        isError() {
            return this.status === STATUS_ERROR;
        },
    },

    methods: {
        handleSubmit() {
            this.status = STATUS_SUBMITTED;

            const { name } = this;

            if (name.trim() === '') {
                return;
            }

            this.save(name);
        },

        async save(name) {
            const { template } = this;

            this.status = STATUS_SAVING;

            try {
                await renameSavedEmailFunnelTemplate({ template, name });

                this.status = STATUS_SAVED;

                this.$toast({ message: `Your template, ${name}, has been saved.` });

                this.$emit('saved', { name });
            } catch (e) {
                this.status = STATUS_ERROR;
            }
        },

        focusNameInput() {
            const { nameInput } = this.$refs;

            if (nameInput) {
                this.$nextTick(() => {
                    nameInput.input_focus();
                });
            }
        },
    },
};
</script>

<style lang="scss" scoped>
.alert-container {
    margin-top: $spacing-200;
}
</style>
